import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { getAuth } from 'firebase/auth';
import { NavLink } from 'react-router-dom';
import { FaStar, FaSearch, FaTimes, FaThumbsUp, FaPlay } from 'react-icons/fa';
import '../styles/Search.css';
import { AudioContext } from '../context/AudioContext';

const genresList = ['Rock', 'Pop', 'Hip-Hop', 'Electronic', 'Jazz', 'Classical', 'Country', 'Blues'];
const trackTypes = ['vocals', 'beat', 'both'];

const Search = () => {
  const { handleTrackClick } = useContext(AudioContext);
  const [trackQuery, setTrackQuery] = useState('');
  const [selectedGenres, setSelectedGenres] = useState([]);
  const [trackType, setTrackType] = useState('');
  const [results, setResults] = useState([]);
  const [currentUserId, setCurrentUserId] = useState(null);

  const auth = getAuth();

  useEffect(() => {
    const user = auth.currentUser;
    if (user) {
      setCurrentUserId(user.uid);
    }
  }, [auth]);

  const fetchSearchResults = async () => {
    if (trackQuery.trim() === '' && selectedGenres.length === 0 && trackType === '') {
      setResults([]);
      return;
    }

    try {
      const response = await axios.get('https://sync-api-troz.onrender.com/api/search', {
        params: {
          trackName: trackQuery,
          genres: selectedGenres,
          trackType: trackType,
        },
      });
      setResults(response.data);
    } catch (error) {
      console.error('Error fetching search results:', error);
    }
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(fetchSearchResults, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [trackQuery, selectedGenres, trackType]);

  const clearSearch = () => {
    setTrackQuery('');
    setResults([]);
  };

  const handleGenreClick = (genre) => {
    setSelectedGenres((prev) =>
      prev.includes(genre) ? prev.filter((g) => g !== genre) : [...prev, genre]
    );
  };

  const handleTrackTypeClick = (type) => {
    setTrackType(type === trackType ? '' : type);
  };

  const handleStarTrack = async (trackId, trackUserId) => {
    if (trackUserId === currentUserId) {
      alert("You can't star your own track.");
      return;
    }

    try {
      await axios.post('https://sync-api-troz.onrender.com/api/uploads/star', {
        trackId,
        userId: currentUserId,
      });
      alert('Track starred successfully!');
      setTrackQuery('');
    } catch (error) {
      if (error.response?.data?.message === 'You have already starred a track from this artist') {
        alert('You already starred a track from this user.');
      } else {
        console.error('Error starring track:', error);
        alert('An error occurred while starring the track.');
      }
    }
  };

  const handleLikeTrack = async (trackId, trackUserId) => {
    if (trackUserId === currentUserId) {
      alert("You can't like your own track.");
      return;
    }

    try {
      await axios.post('https://sync-api-troz.onrender.com/api/uploads/like', {
        trackId,
        firebaseUid: currentUserId,
      });
      alert('Track liked successfully!');
      fetchSearchResults();
    } catch (error) {
      console.error('Error liking track:', error);
      alert('An error occurred while liking the track.');
    }
  };

  return (
    <div className="search-page">
      <div className="search-container">
        <h2 className="search-title">Search Music</h2>

        <div className="search-sticky-bar">
          <div className="search-input-container">
            <FaSearch className="search-search-icon" />
            <input
              id="search-track-input"
              type="text"
              value={trackQuery}
              onChange={(e) => setTrackQuery(e.target.value)}
              placeholder="Search by track name"
              className="search-input"
            />
            {trackQuery && (
              <FaTimes className="search-clear-icon" onClick={clearSearch} />
            )}
          </div>
        </div>

        <div className="search-form-group">
          <label className="search-form-label">Track Type</label>
          <div className="search-picker-container">
            {trackTypes.map((type) => (
              <button
                key={type}
                type="button"
                className={`search-picker-option ${trackType === type ? 'selected' : ''}`}
                onClick={() => handleTrackTypeClick(type)}
              >
                {type.charAt(0).toUpperCase() + type.slice(1)}
              </button>
            ))}
          </div>
        </div>

        <div className="search-form-group">
          <label className="search-form-label">Genres</label>
          <div className="search-picker-container">
            {genresList.map((genre) => (
              <button
                key={genre}
                className={`search-picker-option ${selectedGenres.includes(genre) ? 'selected' : ''}`}
                onClick={() => handleGenreClick(genre)}
              >
                {genre}
              </button>
            ))}
          </div>
        </div>

        <div className="search-results">
          {results.length > 0 ? (
            results.map((upload) => (
              <div key={upload._id} className="search-result-item" onClick={() => handleTrackClick(upload)}>
                <div className="search-result-container">
                  {upload.coverPhoto && (
                    <img src={upload.coverPhoto} alt="cover-photo" className="search-cover" />
                  )}
                  <div className="search-result-details">
                    <h3 className="search-result-title">{upload.title}</h3>
                    <p className="search-artist-upload">
                      {upload.artistName} • {upload.genre}
                    </p>
                    {/* <div className="search-likes-plays-section">
                      <div className="search-plays-count">
                        <FaPlay className="search-play-icon" />
                        <span>{upload.plays}</span>
                      </div>
                      <div className={`search-stars-count ${upload.user === currentUserId ? '' : 'starred'}`}>
                        <FaStar
                          className="search-star-icon"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleStarTrack(upload._id, upload.user);
                          }}
                          style={{ color: upload.user === currentUserId ? '#ccc' : '#fff' }}
                        />
                        <span>{upload.stars}</span>
                      </div>
                      <div className={`search-likes-count ${upload.likedBy?.includes(currentUserId) ? 'liked' : ''}`}>
                        <FaThumbsUp
                          className="search-like-icon"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleLikeTrack(upload._id, upload.user);
                          }}
                        />
                        <span>{upload.likes}</span>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="search-no-results">
              <span>No results found. Upload a track yourself!</span>
              <NavLink to="/upload" className="search-no-results-btn">
                Upload Now
              </NavLink>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Search;